// components/SubscriptionContainer.tsx
import React, { useEffect, useState } from 'react';
import { Container, Box, useMediaQuery, Theme, Typography } from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import { subscriptionSelector, authSelector } from '@/store/selectors';
import { getProducts, setSelectedTier } from '@/store/actions';
import SubscriptionInfo from './components/SubscriptionInfo';
import SubscriptionPlanCard from './components/SubscriptionPlanCard';
import SingleStoryPurchaseCard from './components/SingleStoryPurchaseCard';

interface SubscriptionContainerProps {
  handleNext: () => void;
}

const SubscriptionContainer: React.FC<SubscriptionContainerProps> = ({ handleNext }) => {
  const dispatch = useDispatch();
  const { products, actionSuccess, selectedTier } = useSelector(subscriptionSelector); // selectedTier from Redux
  const { user } = useSelector(authSelector); // Get user data
  const [selectedPlan, setSelectedPlan] = useState<string | null>(selectedTier?.priceId || null); // Initial value from Redux
  const isMobile = useMediaQuery((theme: Theme) => theme.breakpoints.down('md'));
  useEffect(() => {
    dispatch(getProducts({}));
  }, [dispatch, actionSuccess]);

  useEffect(() => {
    if (selectedTier) {
      setSelectedPlan(selectedTier.priceId); // Set selected plan based on Redux state
    }
  }, [selectedTier]);

  const handlePlanSelect = (priceId: string, price: any, productId: string) => {
    setSelectedPlan(priceId);
    dispatch(setSelectedTier({ productId, priceId, Tier: price })); // Store in Redux
    setTimeout(()=>{},2000)
    handleNext();
  };

  const handleSingleStoryPurchaseSelect = () => {
    setSelectedPlan('single_story_purchase');
    dispatch(setSelectedTier({
      productId: 'single_story_purchase',
      priceId: 'single_story_purchase',
      Tier: { isSinglePurchase: true }
    }));
    setTimeout(()=>{},2000)
    handleNext();
  };



  return (
    <Container  sx={{ padding:isMobile ? '0rem' :'1rem 0', overflow:'auto' }}>
      {/* Informational message for users with existing single story purchase */}
      {user?.hasSingleStoryPurchase && !user?.isSubscriber && (
        <Box
          sx={{
            backgroundColor: '#E8F4FD',
            border: '1px solid #0072CE',
            borderRadius: '12px',
            padding: '24px',
            margin: '50px 30px 0 30px',
          }}
        >
          <Typography fontSize={'0.85rem'} color={'#004085'} lineHeight={1.6}>
            Your purchase is for a single Story hosted for 5 years. If you would like to subscribe to be able to create more stories, please contact{' '}
            <a
              href="mailto:support@memvy.com"
              style={{
                color: '#0072CE',
                textDecoration: 'underline',
                fontWeight: 600
              }}
            >
              support@memvy.com
            </a>
            .
          </Typography>
        </Box>
      )}

      {/* Hide subscription options if user already has a single story purchase */}
      {!(user?.hasSingleStoryPurchase && !user?.isSubscriber) && products &&
        products.map((product: any) => (
          <Box key={product.productId}>
            <Box width={isMobile? '100%': '80%'} margin={'0 auto'} >
              <SubscriptionInfo  />
            </Box>
            {/* Subscription Plans + Single Story Side by Side */}
            <Box
              justifyContent={'center'}
              display={isMobile ? 'grid' : 'flex'}
              sx={{
                flex: '1',
                height: '100%',
                overflow: 'auto',
                gap: '1rem',
                width: '100%',
              }}
            >
              {product?.prices?.map((price: any) => (
                <SubscriptionPlanCard
                  key={price.priceId}
                  price={price}
                  selectedPlan={selectedPlan}
                  onSelect={(priceId) => handlePlanSelect(priceId, price, product.stripeProductId)}
                />
              ))}
              <Box sx={{ minWidth: '250px', maxWidth: '250px' }}>
                <SingleStoryPurchaseCard
                  onSelect={handleSingleStoryPurchaseSelect}
                  isSelected={selectedPlan === 'single_story_purchase'}
                />
              </Box>
            </Box>
            <Box width={isMobile? '100%': '90%'} margin={'0 auto'}>

                {/* <FAQ/> */}


            </Box>
          </Box>
        ))}
    </Container>
  );
};

export default SubscriptionContainer;
